
import { useState } from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';

interface Publication {
  id: number;
  authors: string;
  titlePt: string;
  titleEn: string;
  venue: string;
  year: string;
  type: 'article' | 'book-author' | 'book-coauthor';
}

const articles: Publication[] = [
  {
    id: 1,
    authors: 'Pacheco, P.; Paulilo, MTS; Siminski, A.',
    titlePt: 'Estudos comparativos de Cecropia glazioui sob diferentes condições ambientais.',
    titleEn: 'Comparative studies of Cecropia glazioui under different environmental conditions.',
    venue: 'Congresso Brasileiro de Fisiologia Vegetal, Atibaia',
    year: '2002',
    type: 'article'
  },
  {
    id: 2,
    authors: 'Paulilo, MTS; Siminski, A.; Pacheco, P.',
    titlePt: 'Estudos comparativos de Cecropia glazioui em diferentes condições de luz.',
    titleEn: 'Comparative studies of Cecropia glazioui in different light conditions.',
    venue: 'Congresso Brasileiro de Fisiologia Vegetal',
    year: '2003',
    type: 'article'
  },
  {
    id: 3,
    authors: 'Pacheco, P.; Paulilo, MTS.',
    titlePt: 'Efeito da Intensidade Luminosa no Crescimento de Plantas Iniciais de Cecropia glazioui Snethlage (Cecropiaceae).',
    titleEn: 'Effect of Light Intensity on Growth of Initial Plants of Cecropia glazioui Snethlage (Cecropiaceae).',
    venue: 'Revista de Botânica - Insula, Florianópolis, n. 38, p. 28-41. ISSN 0101-9554',
    year: '2009',
    type: 'article'
  },
  {
    id: 4,
    authors: 'Kuck, TN; Keizer, EWH; Pacheco, P.; Lira, R.; Von C. Vasconcelos, SA; Arruda.',
    titlePt: 'Uso multitemporal (2001-2009) da terra no estado amazônico de Mato Grosso por MODIS.',
    titleEn: 'Multitemporal (2001-2009) land use in the Amazon state of Mato Grosso by MODIS.',
    venue: 'Anais XV Simpósio Brasileiro de Sensoriamento Remoto - SBSR, Curitiba, p.7776 INPE',
    year: '2011',
    type: 'article'
  },
  {
    id: 5,
    authors: 'Figueiredo, ALCB; Souza, MMR; Bredariol, IO; Pacheco, P.',
    titlePt: 'Experiência de Manejo de Pirarucu na RESEX Baixo Juruá/AM: Histórico, Perfil dos Pescadores e Avaliação da Atividade Promotora como Ferramenta de Mobilização Social e Participação na Gestão de UC.',
    titleEn: 'Pirarucu Management Experience in RESEX Baixo Juruá/AM: History, Fishermen Profile and Evaluation of Promoter Activity as a Tool of Social Mobilization and Participation in UC Management.',
    venue: 'V SAPIs - Seminário Brasileiro sobre Áreas Protegidas e Inclusão Social',
    year: '2011',
    type: 'article'
  }
];

const booksAuthor: Publication[] = [
  {
    id: 6,
    authors: '',
    titlePt: 'Análise de acurácia dos dados de atividade de desmatamento e degradação para o Projeto de Carbono do Estado do Pará - ArtTree',
    titleEn: 'Accuracy analysis of deforestation and degradation activity data for Para State Carbon Project - ArtTree',
    venue: '',
    year: '',
    type: 'book-author'
  },
  {
    id: 7,
    authors: '',
    titlePt: 'Plataforma Webmap no GEE para biodiversidade do solo em Santa Catarina',
    titleEn: 'Webmap platform on GEE for Santa Catarina soil biodiversity',
    venue: '',
    year: '',
    type: 'book-author'
  },
  {
    id: 8,
    authors: '',
    titlePt: 'Webmap sobre Biodiversidade do solo em Santa Catarina',
    titleEn: 'Webmap on Soil Biodiversity in Santa Catarina',
    venue: '',
    year: '',
    type: 'book-author'
  },
  {
    id: 9,
    authors: '',
    titlePt: 'Dinâmica do desmatamento e Resultados do Projeto Cidades Florestais',
    titleEn: 'Deforestation dynamics and Forest Cities Project Results',
    venue: '',
    year: '',
    type: 'book-author'
  },
  {
    id: 10,
    authors: '',
    titlePt: 'Relatório de Degradação Florestal – Monitoramento da exploração madeireira na Amazônia (SIMEX)',
    titleEn: 'Forest Degradation Report – Logging monitoring in Amazon (SIMEX)',
    venue: '',
    year: '',
    type: 'book-author'
  },
  {
    id: 11,
    authors: '',
    titlePt: 'Cartilla – 1 ¿Qué es REDD+ Jurisdiccional? Lo que necesito saber para comprender esto - Jurisdictional REDD+',
    titleEn: 'Booklet – 1 What is Jurisdictional REDD+? What I need to know to understand this - Jurisdictional REDD+',
    venue: '',
    year: '',
    type: 'book-author'
  },
  {
    id: 12,
    authors: '',
    titlePt: 'Cartilla 5 - El anidamiento de proyectos y derechos de carbono - Jurisdictional REDD',
    titleEn: 'Booklet 5 - Project nesting and carbon rights - Jurisdictional REDD',
    venue: '',
    year: '',
    type: 'book-author'
  }
];

const booksCoauthor: Publication[] = [
  {
    id: 13,
    authors: '',
    titlePt: 'Dados de referência e recomendações para diminuir a introdução e disseminação de espécies exóticas invasoras em áreas protegidas federais e estaduais do Brasil',
    titleEn: 'Baseline data and recommendations to decrease the introduction and spread of invasive non-native species in federal and state protected areas in Brazil',
    venue: '',
    year: '',
    type: 'book-coauthor'
  },
  {
    id: 14,
    authors: '',
    titlePt: 'Monitoramento da degradação florestal no Interflúvio Madeira-Purus: análise da exploração madeireira',
    titleEn: 'Forest degradation monitoring in the Madeira-Purus Interfluve: logging analysis',
    venue: '',
    year: '',
    type: 'book-coauthor'
  },
  {
    id: 15,
    authors: '',
    titlePt: 'A evolução da exploração madeireira na Amazônia Legal nas últimas décadas',
    titleEn: 'The evolution of logging in the Legal Amazon in recent decades',
    venue: '',
    year: '',
    type: 'book-coauthor'
  },
  {
    id: 16,
    authors: '',
    titlePt: 'Estudo sobre resíduos florestais, produção de energia e gestão em diferentes rotas energéticas e biochar',
    titleEn: 'Study on forest residues, energy production and management in different energy routes and biochar',
    venue: '',
    year: '',
    type: 'book-coauthor'
  },
  {
    id: 17,
    authors: '',
    titlePt: 'Cumplicidade na destruição III – APIB/Amazon Watch',
    titleEn: 'Complicity in destruction III – APIB/Amazon Watch',
    venue: '',
    year: '',
    type: 'book-coauthor'
  },
  {
    id: 18,
    authors: '',
    titlePt: 'Bioeconomia na Amazônia e matchmaking para capacitação',
    titleEn: 'Bioeconomy in Amazon and matchmaking for capacity building',
    venue: '',
    year: '',
    type: 'book-coauthor'
  },
  {
    id: 19,
    authors: '',
    titlePt: 'Plano de Gestão da RDS Rio Negro',
    titleEn: 'Rio Negro RDS Management Plan',
    venue: '',
    year: '',
    type: 'book-coauthor'
  },
  {
    id: 20,
    authors: '',
    titlePt: 'PDD ECOMAPUA',
    titleEn: 'PDD ECOMAPUA',
    venue: '',
    year: '',
    type: 'book-coauthor'
  },
  {
    id: 21,
    authors: '',
    titlePt: 'PDD Amazon RIO REDD+ IFM',
    titleEn: 'PDD Amazon RIO REDD+ IFM',
    venue: '',
    year: '',
    type: 'book-coauthor'
  },
  {
    id: 22,
    authors: '',
    titlePt: 'Abate na Amazônia / Greenpeace International',
    titleEn: 'Slaughtering in Amazon / Greenpeace International',
    venue: '',
    year: '',
    type: 'book-coauthor'
  },
  {
    id: 23,
    authors: '',
    titlePt: 'PDD Carvoaria Amazônia / Greenpeace International',
    titleEn: 'PDD Carvoaria Amazônia / Greenpeace International',
    venue: '',
    year: '',
    type: 'book-coauthor'
  },
  {
    id: 24,
    authors: '',
    titlePt: 'PDD MAISA',
    titleEn: 'PDD MAISA',
    venue: '',
    year: '',
    type: 'book-coauthor'
  },
  {
    id: 25,
    authors: '',
    titlePt: 'Botucatu às margens do Tietê: Cultura e sustentabilidade',
    titleEn: 'Botucatu on the banks of the Tietê: Culture and sustainability',
    venue: '',
    year: '',
    type: 'book-coauthor'
  }
];

type TabType = 'articles' | 'books-author' | 'books-coauthor';

export default function Publications() {
  const { language, t } = useLanguage();
  const [activeTab, setActiveTab] = useState<TabType>('articles');

  const getTitle = (pub: Publication) => {
    return language === 'pt' ? pub.titlePt : pub.titleEn;
  };

  const tabs: { key: TabType; labelKey: string; count: number }[] = [
    { key: 'articles', labelKey: 'publications.tab.articles', count: articles.length },
    { key: 'books-author', labelKey: 'publications.tab.author', count: booksAuthor.length },
    { key: 'books-coauthor', labelKey: 'publications.tab.coauthor', count: booksCoauthor.length },
  ];

  const currentList = activeTab === 'articles' ? articles : activeTab === 'books-author' ? booksAuthor : booksCoauthor;

  return (
    <section id="publications" className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="w-2 h-2 rounded-full bg-[#ff6b4a]"></div>
            <span className="text-[#f5f1e8]/70 text-sm font-medium uppercase tracking-wider">
              {t('publications.badge')}
            </span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-serif font-bold text-white mb-4">
            {t('publications.title')}
          </h2>
          <p className="text-[#f5f1e8]/70 text-lg max-w-2xl mx-auto">
            {t('publications.description')}
          </p>
        </div>

        {/* Tabs */}
        <div className="flex justify-center mb-12">
          <div className="inline-flex bg-white/10 backdrop-blur-sm rounded-full p-1">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={`px-6 py-3 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-2 ${
                  activeTab === tab.key
                    ? 'bg-[#ff6b4a] text-white shadow-lg'
                    : 'text-[#f5f1e8]/70 hover:text-white hover:bg-white/10'
                }`}
              >
                {t(tab.labelKey)}
                <span className={`inline-flex items-center justify-center w-6 h-6 rounded-full text-xs font-bold ${
                  activeTab === tab.key ? 'bg-white/20 text-white' : 'bg-white/10 text-[#f5f1e8]/60'
                }`}>
                  {tab.count}
                </span>
              </button>
            ))}
          </div>
        </div>

        {/* Publications List */}
        <div className="space-y-4">
          {currentList.map((pub, index) => (
            <div
              key={pub.id}
              className="bg-[#f5f1e8]/95 backdrop-blur-sm rounded-xl p-6 hover:shadow-xl transition-all duration-300 hover:transform hover:-translate-y-1 group"
            >
              <div className="flex items-start gap-5">
                <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-full bg-[#1a4d2e] text-white font-bold text-sm">
                  {index + 1}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-[#1a4d2e] font-semibold text-base leading-relaxed mb-2 group-hover:text-[#ff6b4a] transition-colors">
                    {getTitle(pub)}
                  </h3>
                  {pub.authors && (
                    <p className="text-gray-500 text-sm mb-1">
                      <i className="ri-user-line mr-1"></i>
                      {pub.authors}
                    </p>
                  )}
                  <div className="flex flex-wrap items-center gap-3 mt-2">
                    {pub.venue && (
                      <span className="text-gray-500 text-xs flex items-center gap-1">
                        <i className="ri-book-open-line"></i>
                        {pub.venue}
                      </span>
                    )}
                    {pub.year && (
                      <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-[#1a4d2e]/10 text-[#1a4d2e] text-xs font-medium rounded-full">
                        <i className="ri-calendar-line"></i>
                        {pub.year}
                      </span>
                    )}
                    <span className={`inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-full ${
                      pub.type === 'article' 
                        ? 'bg-[#ff6b4a]/10 text-[#ff6b4a]' 
                        : pub.type === 'book-author'
                        ? 'bg-[#1a4d2e]/10 text-[#1a4d2e]'
                        : 'bg-[#8b6f47]/10 text-[#8b6f47]'
                    }`}>
                      <i className={`${pub.type === 'article' ? 'ri-article-line' : 'ri-book-2-line'}`}></i>
                      {pub.type === 'article' ? t('publications.type.article') : pub.type === 'book-author' ? t('publications.type.author') : t('publications.type.coauthor')}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Summary */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center border border-white/10">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-full bg-[#ff6b4a]/20">
              <i className="ri-article-line text-[#ff6b4a] text-xl"></i>
            </div>
            <div className="text-3xl font-bold text-white mb-1">{articles.length}</div>
            <div className="text-[#f5f1e8]/60 text-sm">{t('publications.summary.articles')}</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center border border-white/10">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-full bg-[#1a4d2e]/30">
              <i className="ri-book-2-line text-[#4a7c59] text-xl"></i>
            </div>
            <div className="text-3xl font-bold text-white mb-1">{booksAuthor.length}</div>
            <div className="text-[#f5f1e8]/60 text-sm">{t('publications.summary.author')}</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center border border-white/10">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-full bg-[#8b6f47]/20">
              <i className="ri-team-line text-[#8b6f47] text-xl"></i>
            </div>
            <div className="text-3xl font-bold text-white mb-1">{booksCoauthor.length}</div>
            <div className="text-[#f5f1e8]/60 text-sm">{t('publications.summary.coauthor')}</div>
          </div>
        </div>
      </div>
    </section>
  );
}
